export default __webpack_public_path__ + "static/media/caleb-01-icon.8ac28dee.svg";